import Alert from "@mui/material/Alert";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import WarningTwoToneIcon from "@mui/icons-material/WarningTwoTone";
import InfoTwoToneIcon from "@mui/icons-material/InfoTwoTone";
import { SxProps } from "@mui/material/styles";

type BannerFeedbackProps = {
  type: "error" | "warning" | "info" | "success";
  id?: string;
  open: boolean;
  message: string;
  sx?: SxProps;
  callback?: () => void;
};

export function BannerFeedback(props: BannerFeedbackProps) {
  function getPattern() {
    switch (props.type) {
      case "error":
        return "danger";
      case "warning":
        return "warning";
      case "info":
        return "info";
      case "success":
        return "success";
    }
  }

  const pattern = getPattern();
  const AlertSX: SxProps = {
    backgroundColor: `var(--${pattern}-2)`,
    color: `var(--${pattern}-12)`,
    borderRadius: "var(--border-radius-xl)",
    marginBottom: "var(--space-4)",
  };

  const AlertIconSX: SxProps = {
    color: `var(--${pattern}-11)`,
    fontSize: "inherit",
  };

  function getIcon() {
    switch (props.type) {
      case "error":
        return <CloseRoundedIcon sx={AlertIconSX} />;
      case "warning":
        return <WarningTwoToneIcon sx={AlertIconSX} />;
      case "info":
        return <InfoTwoToneIcon sx={AlertIconSX} />;
      case "success":
        return <CheckRoundedIcon sx={AlertIconSX} />;
    }
  }

  const icon = getIcon();

  return (
    <Collapse id={props.id} in={props.open} sx={props.sx}>
      <Alert
        sx={AlertSX}
        icon={icon}
        severity="error"
        action={
          props.callback && (
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={props.callback}
            >
              <CloseRoundedIcon fontSize="inherit" />
            </IconButton>
          )
        }
      >
        {props.message}
      </Alert>
    </Collapse>
  );
}
